import { Grid, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import PrimaryButton from './styled-mui-overrides/PrimaryButton';
import SecondaryButton from './styled-mui-overrides/SecondaryButton';

type InLineEditTextFieldProps = {
  content: string;
  onSave: (value: string) => void;
  textVariant?: any;
};
export default function InLineEditTextField(props: InLineEditTextFieldProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(props.content);
  }, [props.content]);

  return (
    <Grid container direction={'column'} rowGap={1}>
      {isEditing ? (
        <Grid item container columnGap={1}>
          <Grid item>
            <TextField
              label=''
              size='small'
              value={value}
              onChange={e => setValue(e.target.value)}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              onClick={() => {
                props.onSave(value);
                setIsEditing(false);
              }}
            >
              Save
            </PrimaryButton>
          </Grid>
          <Grid item>
            <SecondaryButton onClick={() => setIsEditing(false)}>Cancel</SecondaryButton>
          </Grid>
        </Grid>
      ) : (
        <Grid
          item
          sx={{ '&:hover': { backgroundColor: 'secondary.light' }, paddingY: 1, borderRadius: 2 }}
        >
          <Typography variant={props.textVariant || 'inherit'} onClick={() => setIsEditing(true)}>
            {props.content}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}
